"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Auth0ProviderWithNavigate = void 0;
var _auth0React = require("@auth0/auth0-react");
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Auth0ProviderWithNavigate = ({
  children
}) => {
  const navigate = (0, _reactRouterDom.useNavigate)();
  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const callbackUri = process.env.REACT_APP_AUTH0_CALLBACK_URL;
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE;
  const onRedirectCallback = appState => {
    navigate(appState?.returnTo || window.location.pathname);
  };
  if (!(domain && clientId && callbackUri && audience)) {
    return null;
  }

  // return children

  return /*#__PURE__*/_react.default.createElement(_auth0React.Auth0Provider, {
    domain: domain,
    clientId: clientId,
    authorizationParams: {
      audience: audience,
      redirect_uri: callbackUri
    },
    onRedirectCallback: onRedirectCallback
  }, children);
};
exports.Auth0ProviderWithNavigate = Auth0ProviderWithNavigate;